import { functions } from "../firebase";
import {
  StripeConnectStatus,
  StripePlanDisplay,
  StripePlanKey,
  StripeSummary,
} from "../../types/Stripe";

export const getStripeConnectStatus = async (
  communityId: string
): Promise<StripeConnectStatus> => {
  const callable = functions.httpsCallable("getStripeConnectStatus");
  const result = await callable({ communityId });
  return (result.data || {}) as StripeConnectStatus;
};

export const connectStripeAccount = async (params: {
  communityId: string;
  secretKey: string;
}): Promise<StripeConnectStatus> => {
  const callable = functions.httpsCallable("connectStripeAccount");
  const result = await callable(params);
  return (result.data || {}) as StripeConnectStatus;
};

// Store the RevenueCat Stripe app's public key (strp_...) so the webhook
// forwards web purchases into RevenueCat's metrics. Empty key unlinks.
export const setStripeRevenueCatKey = async (params: {
  communityId: string;
  rcStripePublicKey: string;
}): Promise<StripeConnectStatus> => {
  const callable = functions.httpsCallable("setStripeRevenueCatKey");
  const result = await callable(params);
  return (result.data || {}) as StripeConnectStatus;
};

// Web revenue stats read straight off the coach's Stripe account: active
// subscriptions, trials, MRR, 28-day revenue and a recent subscriber list.
export const getStripeSummary = async (
  communityId: string
): Promise<StripeSummary> => {
  const callable = functions.httpsCallable("getStripeSummary");
  const result = await callable({ communityId });
  return (result.data || {}) as StripeSummary;
};

export const provisionStripePrices = async (params: {
  communityId: string;
  plans: Array<{
    interval: "week" | "month" | "year";
    amount: number;
    currency?: string;
  }>;
}): Promise<{ priceIds: Partial<Record<StripePlanKey, string>>; prices: StripePlanDisplay[] }> => {
  const callable = functions.httpsCallable("provisionStripePrices");
  const result = await callable(params);
  return (result.data || {}) as {
    priceIds: Partial<Record<StripePlanKey, string>>;
    prices: StripePlanDisplay[];
  };
};
